import { IPagination } from 'app/types/common';

export interface IGroup {

}

export interface IGroupsState {
  readonly groupsById?: any;
  readonly groupIds?: string[];
  readonly hasLoaded?: boolean;
  readonly hasLoaded?: boolean;
  readonly hasSaved?: boolean;
  readonly hasFailed?: boolean;
  readonly isLoading?: boolean;
  readonly isSaving?: boolean;
  readonly selectGroupLoading?: boolean;
  readonly hasLoaded?: boolean;
  readonly showAddGroup?: boolean;
  readonly requestedData?: any;
  readonly backendErrors?: any;
  readonly organisationGroupIds?: string[];
  readonly currentGroupId?: string;
  readonly filterConfig?: any;
  readonly sortConfig?: any;
  readonly pagination?: IPagination;
}

export interface IGroupsSelector extends IGroupsState {
  readonly currentGroup?: any;
  readonly currentFormGroup?: any;
  readonly groupsFilteredByTagInSelectFormat?: any;
  readonly groupsByIdInSelectFormat?: any;
}

export enum GroupsActionTypes {
  GET_ALL_GROUPS_REQUESTED = 'redux-app/groups/GET_ALL_GROUPS_REQUESTED',
  GET_ALL_GROUPS_PENDING = 'redux-app/groups/GET_ALL_GROUPS_PENDING',
  GET_ALL_GROUPS_SUCCESS = 'redux-app/groups/GET_ALL_GROUPS_SUCCESS',
  GET_ALL_GROUPS_FAIL = 'redux-app/groups/GET_ALL_GROUPS_FAIL',
  GET_GROUP_REQUESTED = 'redux-app/groups/GET_GROUP_REQUESTED',
  GET_GROUP_PENDING = 'redux-app/groups/GET_GROUP_PENDING',
  GET_GROUP_SUCCESS = 'redux-app/groups/GET_GROUP_SUCCESS',
  GET_GROUP_FAIL = 'redux-app/groups/GET_GROUP_FAIL',
  UPDATE_GROUP_REQUESTED = 'redux-app/groups/UPDATE_GROUP_REQUESTED',
  UPDATE_GROUP_PENDING = 'redux-app/groups/UPDATE_GROUP_PENDING',
  UPDATE_GROUP_SUCCESS = 'redux-app/groups/UPDATE_GROUP_SUCCESS',
  UPDATE_GROUP_FAIL = 'redux-app/groups/UPDATE_GROUP_FAIL',
  CREATE_GROUP_REQUESTED = 'redux-app/groups/CREATE_GROUP_REQUESTED',
  CREATE_GROUP_PENDING = 'redux-app/groups/CREATE_GROUP_PENDING',
  CREATE_GROUP_SUCCESS = 'redux-app/groups/CREATE_GROUP_SUCCESS',
  CREATE_GROUP_FAIL = 'redux-app/groups/CREATE_GROUP_FAIL',
  DELETE_GROUP_REQUESTED = 'redux-app/groups/DELETE_GROUP_REQUESTED',
  DELETE_GROUP_PENDING = 'redux-app/groups/DELETE_GROUP_PENDING',
  DELETE_GROUP_SUCCESS = 'redux-app/groups/DELETE_GROUP_SUCCESS',
  DELETE_GROUP_FAIL = 'redux-app/groups/DELETE_GROUP_FAIL',
  SELECT_GROUP_REQUESTED = 'redux-app/groups/SELECT_GROUP_REQUESTED',
}

export default null;
